module.exports = __webpack_public_path__ + "static/media/ill_coming_soon.575c6b21.svg";